<template>
  <div class="page1">
    <EForm :formColumns="formColumns" :rowSize="5" :optionsBtn="true" :actionBtn="false" :formData="searchForm"
      ref="form" @onSearch="onSearch" :searchFlag="true" :exportShow="false"></EForm>
    <EButton @click="dialogVisible = true">新增</EButton>
    <el-button type="danger" size="small" plain @click="deleteMore">删除</el-button>
    <ETable :tableTitle="tableTitle" :tableData="tableData" :needPagination="true" :count="count"
      @changePage="changePage" @changeSize="changeSize" :page="searchForm.current" :page_size="searchForm.size" @handleSelect="handleSelectionChange"
            :needSelect="true">
      <el-table-column fixed="right" label="操作" width="180px">
        <template slot-scope="scope">
          <div>
            <EButton type="text" @click="editDialog(scope.row)">修改</EButton>
            <!--                        <el-button type="text " @click="userDetail(scope.row.user_id)">编辑-->
            <!--                        </el-button>-->
          </div>
        </template>
      </el-table-column>
      <div slot="status" slot-scope="scope">
        {{ scope.data.status == 0 ? '未发布' : '已发布' }}
      </div>
    </ETable>
    <EDialog :dialogVisible="dialogVisible" :title="title" @handleClose="handleClose" width="60%"
      @handleClick="saveData">
      <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="正文" required>
              <div class="ql-height">
                <vue-editor v-model="form.content"></vue-editor>
                <!--quill-editor :class="[disabled ? 'is-disabled' : '']" v-model="form.content" ref="myQuillEditor"
                  :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                  @change="onEditorChange($event)">
                </quill-editor-->
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="0">未发布</el-radio>
                <el-radio :label="1">已发布</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </EDialog>
  </div>
</template>

<script>
import ETable from '@/components/ETable'
import Http from "@/service/http";
import EDialog from '@/components/EDialog'
import EButton from '@/components/EButton'
import EForm from '@/components/EForm'
import vxRule from "@/assets/js/formValidate";
import { mapGetters } from 'vuex'
import { Base64 } from 'js-base64';
import {VueEditor} from 'vue2-editor'

// 工具栏配置
  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
    ["blockquote", "code-block"], // 引用  代码块
    [{header: 1}, {header: 2}], // 1、2 级标题
    [{list: "ordered"}, {list: "bullet"}], // 有序、无序列表
    // [{script: "sub"}, {script: "super"}], // 上标/下标
    [{indent: "-1"}, {indent: "+1"}], // 缩进
    // [{'direction': 'rtl'}],                         // 文本方向
    [{size: ["small", false, "large", "huge"]}], // 字体大小
    [{header: [1, 2, 3, 4, 5, 6, false]}], // 标题
    [{color: []}, {background: []}], // 字体颜色、字体背景颜色
    [{font: []}], // 字体种类
    [{align: []}], // 对齐方式
    ["clean"], // 清除文本格式
    // ["link", "image"] // 链接、图片、视频
  ];

export default {
  name: 'Login',
  data() {
    return {
      formColumns: [
        {
          title: '标题',
          type: 'text',
          property: 'title',
          placeHolder: '请输入',
          show: true,
        },
        {
          title: '发布状态',
          type: 'select',
          property: 'status',
          show: true,
          options: [
            {
              label: '全部',
              value: '',
            },
            {
              label: '未发布',
              value: 0,
            },
            {
              label: '已发布',
              value: 1,
            },
          ],
        },],
      tableTitle: [
        {
          label: '标题',
          prop: 'title',
        },
        {
          label: '创建时间',
          prop: 'createTime',
        },
        {
          label: '发布状态',
          prop: 'status',
          type: 'slot'
        },],
      tableData: [],
      loading: false,
      dialogVisible: false,
      title: '添加信息',
      form: {
        id: '',
        title: '',
        content: '',
        status: 0
      },
      searchForm: {
        title: '',
        status: '',
        current: 1,
        size: 10
      },
      cascader: false,
      options: [],
      count: null,
      formRules: {
        title: [vxRule(true, '', "blur", "标题不能为空")],
      },
      labelPosition: 'right',
      labelWidth: '100px',
      selectRoutes: [],
      editorOption: {
        theme: 'snow',
        placeholder: '在这里开始写正文',
        modules: {
          toolbar: {
            container: toolbarOptions,
            // container: "#toolbar",
            handlers: {
              'image': function () {
                // 调用iview图片上传
                document.querySelector('.upLoad').click()
                this.quill.format('image', false)

              }
            }
          },
        },
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {},
  created() {
    this.getData()
    //this.getOptions()
  },
  components: { ETable, EDialog, EButton, EForm,VueEditor },
  beforeMount() {

  },
  methods: {
    handleSuccess(res) {
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill
        // 如果上传成功
        if (res) {
          // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          quill.insertEmbed(length, 'image', res)
          // 调整光标到最后
          quill.setSelection(length + 1)
        } else {
          // 提示信息，需引入Message
          this.$message.error('图片插入失败')
        }
      },
      async getFileUpload(event, flag) {//获取文件信息上传
        let file = event.target.files[0]
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        let res = await Http.uploadImg({'file': file},[], true)
        if (res.code === 200) {
          this.handleSuccess(res.data.url)
        }
        loading.close()
        // uploadImage(file, 'image_content').then((res) => {
        //   if (res.flag === '1') {
        //     if (flag == 'cover') {
        //       this.form.cover_image = res.data.res
        //     } else {
        //       this.handleSuccess(res.data.res)
        //     }
        //     loading.close()
        //   }
        // })
      },
      onEditorBlur() {
      }, // 失去焦点事件
      onEditorFocus() {
      }, // 获得焦点事件
      onEditorChange() {
      }, // 内容改变事件
    onSearch() {
      this.searchForm.current = 1
      this.getData()
    },
    changePage(page) {
      this.searchForm.current = page
      this.getData()
    },
    changeSize(size) {
      this.searchForm.size = size
      this.getData()
    },
    handleClose() {
      this.title = '添加信息'
      this.dialogVisible = false
      this.form = {
        id: '',
        title: '',
        content: '',
        status: 0
      }
      this.$refs.form.resetFields()
    },
    handleSelectionChange(data) {
        if (data.length > 0) {
          data.forEach((item) => {
            this.selectRoutes.push(item.id);
          });
        }
      },
    deleteMore() {
      this.deleteInfo(this.selectRoutes.toString());
    },
    deleteInfo(ids) {
      this.$messageBox
        .confirm(`确定删除该信息吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then((res) => {
          this.removeRoute(ids);
        })
        .catch((res) => {});
    },
    async getData() {
      let res = await Http.policyList(this.searchForm)
      if (res.code == 200) {
        this.tableData = res.data.records
        this.count = res.data.total
      }

    },
    saveData() {
      let flag = false
      this.$refs['form'].validate((valid, object) => {
        if (valid && !this.error) {
          flag = true
        } else {
          return false;
        }
      });
      if (flag) {
        this.addBtn()
      }
    },
    async addBtn() {
      let {
        id,
        title,
        content,
        status
      } = this.form
      let res = await Http.policySave({
        id,
        title,
        content: Base64.encode(content),
        status
      })
      console.log(JSON.stringify(res))
      if (res.code == 200) {
        this.$message.success(res.msg)
        this.handleClose()
        this.getData()
      }
    },
    editDialog(data) {
      this.title = '编辑信息'
      this.form = {
        id: data.id,
        title: data.title,
        content: data.content,
        status: data.status,
      }
      this.dialogVisible = true
    },
    async removeRoute(ids) {
      let res = await Http.policyRemoveRoute({ ids });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;

}
</style>
